// Keep the rule in sync with auth/profile_name.py; names may contain Unicode letters.
export const NAME_INVALID_MESSAGE = 'Enter a valid name.';

export function normalizeProfileName(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
}

export function getProfileNameError(value) {
    return /\p{L}/u.test(normalizeProfileName(value)) ? '' : NAME_INVALID_MESSAGE;
}
